import React from "react";
import { component_tool } from '../../../../tool'
import moment from "moment";
import { WizTableForm } from "../../../common";
let { WizDataTable, WizButton } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

export default (self, planList) => {
  return [
    {
      name: "id",
      key: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: 'applyId',
      name: 'applyId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {},
    },
    {
      title: '组织名称',
      name: 'orgName',
      tableItem: {},
    },
    {
      title: '组织编码',
      name: 'orgCode',
      tableItem: {},
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: '岗位',
      name: 'positionName',
      tableItem: {},
    },
    {
      title: '任职状态',
      name: 'jobState',
      tableItem: {},
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
    },
    {
      title: '安排计划',
      name: 'planId',
      searchItem: {
        type: 'select'
      },
      dict: planList || []
    },
    {
      title: '安排计划',
      name: 'planName',
      tableItem: {},
    },
    {
      title: '报名状态',
      name: 'status',
      searchItem: {
        type: "select"
      },
      tableItem: {},
      dict: [
        { code: 0, codeName: '待审核' },
        { code: 1, codeName: '已通过' },
        { code: 2, codeName: '审核中' },
        { code: 3, codeName: '未通过' },
        { code: 4, codeName: '已取消报名' }
      ]
    },
    {
      title: '报名提交时间',
      name: 'applySubmitTime',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: '申请人账号',
      name: 'applicantUserName',
      tableItem: {},
    },
    {
      title: '申请人姓名',
      name: 'applicantFullName',
      tableItem: {},
    },
    {
      title: "操作",
      tableItem: {
        fixed: 'right',
        render: (text, record) => {
          return self._onLook(record)
        }
      }
    }
  ]
}
